"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RentersAssumptionsPopupWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var RentersAssumptionsPopupWidget = /** @class */ (function (_super) {
    __extends(RentersAssumptionsPopupWidget, _super);
    function RentersAssumptionsPopupWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.journeyState = _this.props.engine.getJourneyState();
        _this.renderBody = function () {
            return (React.createElement("div", { className: "font-family-base font-weight-extra-light line-height-15" },
                "Please check that all the statements below are correct:",
                React.createElement("ul", { className: "font-family-inherit font-weight-inherit line-height-inherit" },
                    React.createElement("li", { className: "mt-3" },
                        "The property is your main home and not left unoccupied for more than ",
                        React.createElement("b", { className: "font-weight-semi-bold" }, "30 days"),
                        " in a row."),
                    React.createElement("li", { className: "mt-3" },
                        "You or anyone living with you does not have ",
                        React.createElement("b", { className: "font-weight-semi-bold" }, "any unspent criminal convictions"),
                        "."),
                    React.createElement("li", { className: "mt-3" },
                        "The ",
                        React.createElement("b", { className: "font-weight-semi-bold" }, "property isn\u2019t used for business purposes"),
                        " [other than home office work]."),
                    React.createElement("li", { className: "mt-3" },
                        "To your knowledge ",
                        React.createElement("b", { className: "font-weight-semi-bold" }, "the property has never suffered from flooding"),
                        " and/or is it located in an area which is under current flood warning.")),
                React.createElement("div", { className: "w-100 m-auto pt-3" },
                    _this.renderRadios(),
                    !_this.state.isAgreed && _this.state.isAgreed !== undefined && _this.renderAlert())));
        };
        _this.renderRadios = function () {
            return (React.createElement("div", { className: "input-group w-100 d-flex justify-content-center flex-column flex-md-row pb-0" },
                React.createElement("div", { className: "custom-control custom-radio width-md-200 w-100" },
                    React.createElement("input", { id: "agree-true", className: "custom-control-input", type: "radio", name: "agree-true", value: "true", checked: _this.state.isAgreed, onChange: _this.handleChange }),
                    React.createElement("label", { className: "custom-control-label", htmlFor: "agree-true" }, "Yes, I agree")),
                React.createElement("div", { className: "custom-control custom-radio width-md-200 w-100" },
                    React.createElement("input", { id: "agree-false", className: "custom-control-input", type: "radio", name: "agree-false", value: "false", checked: _this.state.isAgreed === undefined ? false : !_this.state.isAgreed, onChange: _this.handleChange }),
                    React.createElement("label", { className: "custom-control-label", htmlFor: "agree-false" }, "No, I don't agree"))));
        };
        _this.renderAlert = function () {
            return (React.createElement("div", { className: "px-md-4 d-flex align-items-center" },
                React.createElement("img", { className: "d-block mx-3 h-30", src: "/img/alert-grey-blue.svg", alt: "Alert icon" }),
                React.createElement("div", null,
                    "Sorry, we can\u2019t insure you",
                    React.createElement("br", null),
                    "OK, I understand")));
        };
        _this.closeModal = function () {
            _this.props.engine.setJourneyState({ showRentersAssumptionsPopup: false });
        };
        _this.proceedNext = function () {
            _this.props.engine.setJourneyState({ showRentersAssumptionsPopup: false });
            _this.executeEvent("click");
        };
        _this.handleChange = function (event) {
            if (event.target.value === "true") {
                _this.setState({ isAgreed: true });
            }
            else {
                _this.setState({ isAgreed: false }, function () {
                    var element = document.querySelector(".modal-body");
                    element.scrollTop = element.scrollHeight;
                });
            }
        };
        _this.state = {
            isAgreed: undefined
        };
        return _this;
    }
    RentersAssumptionsPopupWidget.prototype.render = function () {
        return (React.createElement(reactstrap_1.Modal, { className: "falcon-modal", isOpen: this.journeyState.showRentersAssumptionsPopup, toggle: this.closeModal, centered: true, fade: false, scrollable: true },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.closeModal, close: React.createElement("button", { className: "btn-close", onClick: this.closeModal }) },
                React.createElement("div", { className: "px-md-4 pt-4 d-flex" },
                    React.createElement("img", { className: "d-block mr-3 mb-1 ml-md-2 info-icon-selected", src: "/img/Flow-info-selected.svg" }),
                    React.createElement("div", { className: "text-blue-2 font-weight-medium font-family-display fs-20" }, "Before we continue"))),
            React.createElement(reactstrap_1.ModalBody, { className: "px-md-5 py-0" }, this.renderBody()),
            React.createElement(reactstrap_1.ModalFooter, { className: "m-md-auto" },
                React.createElement(reactstrap_1.Button, { className: "my-2 btn btn-btn btn-primary btn-next width-md-250", disabled: !this.state.isAgreed, onClick: this.proceedNext }, "Continue to quote"))));
    };
    return RentersAssumptionsPopupWidget;
}(plugin_journey_1.WidgetBase));
exports.RentersAssumptionsPopupWidget = RentersAssumptionsPopupWidget;
//# sourceMappingURL=RentersAssumptionsPopupWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/renters/RentersAssumptionsPopupWidget.js
// module id = 2580
// module chunks = 0